import { TOGGLE_LINE_BANNER } from './constants'

export function toggleLineBanner(id) {
    return {
        type: TOGGLE_LINE_BANNER,
        data: {
            id,
        },
    }
}
